export default {
  default: () => import("/usr/src/nuxt-app/layouts/default.vue").then(m => m.default || m),
  "default-sidebar": () => import("/usr/src/nuxt-app/layouts/default_sidebar.vue").then(m => m.default || m)
}